import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Button,
  FormControlLabel,
  Grid,
  MenuItem,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import AuthService from "../../../../../AuthService";
import { useConfirm } from "../../../../../components/DialogConfirm";
import ComplementsItens from "./ComplementsItens";
import ListComplements from "./ListComplements";

const TabComplements = ({
  complemento,
  erros,
  optionsCurrency,
  produto,
  validaComplemento,
  handleClickStopAndPause,
  handleSubmit,
  handleChangeProduto,
  grupoAnterior,
  setState,
  handleDisableOrEnableComplement,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const service = new AuthService();
  const handleAddChange = (event) => {
    const tempComplemento = { ...complemento };
    tempComplemento[event.target.name] = event.target.value;
    setState((prev) => ({ ...prev, complemento: tempComplemento }));
  };
  const confirm = useConfirm();
  const handleChangeComplementoCheck = (event) => {
    const tempComplemento = { ...complemento };
    tempComplemento[event.target.name] = event.target.checked;
    setState((prev) => ({ ...prev, complemento: tempComplemento }));
  };

  const handleChangeComplementoItem = (event, index, value) => {
    const tempComplemento = { ...complemento };
    tempComplemento.complementoItens[index][event.target.name] =
      value || event.target.value;
    setState((prev) => ({ ...prev, complemento: tempComplemento }));
  };

  const handleAddComplementoItem = (complemento) => {
    const tempComplemento = { ...complemento };
    if (tempComplemento.complementoItens === undefined) {
      tempComplemento.complementoItens = [];
    }
    tempComplemento.complementoItens.push({ descricao: "", valor: "0.00" });
    setState((prev) => ({ ...prev, complemento: tempComplemento }));
  };

  const handleEditarComplemento = (event, complemento) => {
    event.stopPropagation();
    setState((prev) => ({ ...prev, complemento }));
  };
  function replaceValor(valor) {
    if (!valor) return 0;
    const str = String(valor) || "";
    return (
      parseFloat(
        str?.replace("R$", "").replace(/\./g, "").replace(",", ".").trim()
      ) || 0
    );
  }

  const handleSubmitComplemento = (event) => {
    const tempErros = { ...erros };
    var error = false;

    const itens = complemento.complementoItens.map((item) => {
      let value = item.valor;
      let valueFormat;
      if (typeof value === "string") {
        valueFormat = replaceValor(value);
      } else valueFormat = value;
      item.valor = valueFormat;
      if (item.descricao === "") {
        tempErros.descricaoComplemento =
          "O nome do item do complemento é obrigatório!";
        enqueueSnackbar("Descrição do item não informada.", {
          variant: "warning",
        });
        error = true;
      }
      return {
        ...item,
        valor: valueFormat,
      };
    });

    const complementoTem = { ...complemento, complementoItens: itens };

    if (complemento.descricao === "") {
      tempErros.nomeItemComplemento =
        "A descrição do complemento é obrigatória!";
      enqueueSnackbar("Preencha os campos requeridos (Campo: Descrição) ", {
        variant: "warning",
      });
      error = true;
    }

    if (error) {
      setState((prev) => ({ ...prev, erros: tempErros }));
      return;
    }

    const tempComplemento = { ...complementoTem };
    tempComplemento.produto = { id: produto.id };
    let service = new AuthService();

    service
      .post("/complemento", tempComplemento)
      .then((retorno) => {
        enqueueSnackbar("Complemento salvo com sucesso", {
          variant: "success",
        });

        const tempProduto = { ...produto };
        let indexComplemento = tempProduto.complementos.findIndex(
          (el) => el.id === retorno.id
        );

        if (indexComplemento > -1) {
          tempProduto.complementos.splice(indexComplemento, 1);
        }

        tempProduto.complementos.push(retorno);

        handleChangeProduto(tempProduto, "SALVAR", grupoAnterior);
        handleSubmit();
        setState((prev) => ({
          ...prev,
          produto: tempProduto,
          complemento: null,
        }));
      })
      .catch((err) => {
        if (err.response === undefined) {
          enqueueSnackbar("Falha ao tentar salvar o complemento", {
            variant: "error",
          });
        } else {
          err.response.json().then((elem) => {
            enqueueSnackbar(
              "Falha ao salvar o complemento " + elem.errorMessage,
              { variant: "error" }
            );
          });
        }
      });
  };

  const novoComplemento = () => {
    let complemento = {
      id: null,
      descricao: "",
      max: 1,
      min: 0,
      obrigatorio: false,
      ordem: 1,
      complementoItens: [{ descricao: "", valor: "0.00" }],
    };

    setState((prev) => ({ ...prev, complemento }));
  };

  const handleDeletarComplemento = async (event) => {
    const confirmado = await confirm({
      message: "Deseja realmente excluir o complemento?",
    });

    if (!confirmado) return;

    if (complemento.id !== null) {
      let service = new AuthService();
      service
        .delete(`/complemento/${complemento.id}`)
        .then((retorno) => {
          enqueueSnackbar("Complemento excluído com sucesso", {
            variant: "success",
          });

          const tempProduto = { ...produto };
          let index = tempProduto.complementos.findIndex(
            (e) => e.id === complemento.id
          );

          tempProduto.complementos.splice(index, 1);

          handleSubmit();
          setState((prev) => ({ ...prev, produto: tempProduto }));
          novoComplemento();
        })
        .catch((err) => {
          if (err.response === undefined) {
            enqueueSnackbar("Falha ao tentar excluir o complemento", {
              variant: "error",
            });
          } else {
            err.response.json().then((elem) => {
              enqueueSnackbar(
                "Falha ao excluir o complemento " + elem.errorMessage,
                { variant: "error" }
              );
            });
          }
        });
    } else
      setState((prev) => ({
        ...prev,
        complemento: null,
      }));
  };

  const handleRemoveComplementoItem = (complementoItem) => {
    const tempComplemento = { ...complemento };
    let temp = [...tempComplemento.complementoItens];
    let pos = temp.findIndex((r) => r === complementoItem);
    if (complementoItem.id != null) {
      service
        .delete(`/complementoItem/${complementoItem.id}`)
        .then((retorno) => {
          temp.splice(pos, 1);
          tempComplemento.complementoItens = temp;
          enqueueSnackbar("Item do complemento excluido com sucesso", {
            variant: "success",
          });
          setState((prev) => ({ ...prev, complemento: tempComplemento }));
        })
        .catch((err) => {
          enqueueSnackbar("Erro ao tentar excluir item do complemento", {
            variant: "error",
          });
        });
    } else {
      temp.splice(pos, 1);
      tempComplemento.complementoItens = temp;
      setState((prev) => ({ ...prev, complemento: tempComplemento }));
      enqueueSnackbar("Item do complemento excluido com sucesso", {
        variant: "success",
      });
    }
  };

  const handleCheckValue = (event) => {
    const { value } = event.target;

    if (value === "") {
      handleAddChange(event);
      return;
    }

    const qtdComplemento = parseInt(value, 10);
    if (qtdComplemento < 0) {
      event.target.value = 0;
    }

    handleAddChange(event);
  };

  return (
    <>
      {complemento ? (
        <Grid container spacing={1} sx={{ marginBottom: "1.5rem" }}>
          <Grid
            size={{
              xs: 12,
              sm: 5,
            }}
          >
            <TextField
              fullWidth
              variant="outlined"
              label="Descrição do complemento"
              error={erros.descricaoComplemento}
              helperText={erros.descricaoComplemento}
              placeholder="Sabores tradicionais"
              name="descricao"
              required
              value={complemento.descricao || ""}
              onChange={(event) => handleAddChange(event)}
            />
          </Grid>

          <Grid
            size={{
              xs: 6,
              sm: 1,
            }}
          >
            <TextField
              fullWidth
              variant="outlined"
              label={"Ordem"}
              name="ordem"
              value={complemento.ordem || ""}
              onChange={(event) => handleAddChange(event)}
            />
          </Grid>

          <Grid
            size={{
              xs: 6,
              sm: 2,
            }}
          >
            <TextField
              select
              name="tipoComplemento"
              label="Tipo"
              fullWidth
              onChange={(event) => handleAddChange(event)}
              value={complemento.tipoComplemento || ""}
              variant="outlined"
            >
              <MenuItem value="">Nenhum</MenuItem>
              <MenuItem value={"COMPLEMENTO"}>Complemento</MenuItem>
              <MenuItem value="PIZZA_FRACIONADA">
                Sabores de pizzas (valor proporcional)
              </MenuItem>
              <MenuItem value="PIZZA_MAIOR_VALOR">
                Sabores de pizzas (maior valor)
              </MenuItem>
            </TextField>
          </Grid>

          <Grid
            size={{
              xs: 3,
              sm: 1,
            }}
          >
            <TextField
              variant="outlined"
              fullWidth
              label={"Qtd. min."}
              name="min"
              type="number"
              value={parseInt(complemento.min)}
              error={validaComplemento()}
              onChange={(event) => {
                handleCheckValue(event);
                handleAddChange(event);
              }}
              onFocus={(e) => {
                {
                  e.target.value = '';
                  handleAddChange(e);
                }
              }}
              onBlur={(e) => {
                if (e.target.value === '') {
                  e.target.value = 0;
                  handleAddChange(e);
                }
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 3,
              sm: 1,
            }}
          >
            <TextField
              variant="outlined"
              label="Qtd. máx."
              fullWidth
              name="max"
              type="number"
              value={parseInt(complemento.max)}
              error={validaComplemento()}
              onChange={(event) => {
                handleCheckValue(event);
                handleAddChange(event);
              }}
              onFocus={(e) => {
                {
                  e.target.value = '';
                  handleAddChange(e);
                }
              }}
              onBlur={(e) => {
                if (e.target.value === '') {
                  e.target.value = 1;
                  handleAddChange(e);
                }
              }}
            />
          </Grid>

          <Grid
            size={{
              xs: 6,
              sm: 1,
            }}
          >
            <FormControlLabel
              name="ativo"
              labelPlacement="top"
              control={
                <Switch
                  checked={complemento.obrigatorio}
                  color="primary"
                  name="obrigatorio"
                  onChange={(event) => handleChangeComplementoCheck(event)}
                />
              }
              label={"Obrigatório"}
            />
          </Grid>
          <ComplementsItens
            complemento={complemento}
            erros={erros}
            handleChangeComplementoItem={handleChangeComplementoItem}
            optionsCurrency={optionsCurrency}
            handleRemoveComplementoItem={handleRemoveComplementoItem}
          />

          <Grid
            padding="0.5rem"
            container
            direction="row"
            gap="2rem"
            size={{
              xs: 12,
              sm: 12,
            }}
          >
            <Grid>
              <Button
                variant="contained"
                onClick={() => handleAddComplementoItem(complemento)}
                startIcon={<AddIcon />}
                color="primary"
              >
                Adicionar item
              </Button>
            </Grid>

            {!!validaComplemento().text && (
              <Grid>
                <Typography color="error">
                  {validaComplemento().text}
                </Typography>
              </Grid>
            )}

            <Grid>
              <Button
                onClick={(e) => handleDeletarComplemento(e)}
                startIcon={<DeleteIcon />}
              >
                EXCLUIR
              </Button>
            </Grid>

            <Grid>
              <Button

                disabled={
                  complemento.complementoItens === undefined ||
                  complemento.complementoItens.length === 0 ||
                  Number(complemento.max) < Number(complemento.min) ||
                  complemento.max <= 0 || complemento.min < 0
                }
                variant="contained"
                color="secondary"
                onClick={(e) => handleSubmitComplemento(e)}
              >
                SALVAR COMPLEMENTO
              </Button>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid container justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={novoComplemento}
          >
            Adicionar Complemento
          </Button>
        </Grid>
      )}
      <ListComplements
        produto={produto}
        handleEditarComplemento={handleEditarComplemento}
        handleClickStopAndPause={handleClickStopAndPause}
        handleDisableOrEnableComplement={handleDisableOrEnableComplement}
      />
    </>
  );
};

export default TabComplements;
